/**
 * @author Ariel
 * @date 2022-03-18
 */
import React from "react";
import { connect } from "dva";
import moment from "moment";
import { framework_tool, component_tool, utils_tool } from "../../../../tool";
import { formatAuth } from "@/utils/commonUtils";
import {
  WizTableForm,
  WizClassifySelectRe as ClassifySelect,
  WizDataAuthSelect
} from "@/containers/common";
let { WizContainer, modelUtils, WizFileUpload } = framework_tool;
let {
  WizCard,
  WizSpin,
  WizForm,
  WizButton,
  Wizmessage,
  WizCol,
  WizSelect,
  WizInputNumber,
  WizModal,
  WizRow
} = component_tool;
let { Session } = utils_tool;
let Option = WizSelect.Option;

const labelConfig = WizTableForm.Config.label(this, { apiParams: { type: 6, categoryCode: 'verbalTrickLabel' } });
const organizationConfig = WizTableForm.Config.organizationBrandNode(this, {
  apiParams: {
    state: 1,
    organizationNodeCategory: [2],
    isNotAuth: true,
  }
});

const validator = (rule, value, callback) => {
  if (value) {
    if (value.groupId) {
      callback();
      return;
    }
    if (value.orgIds && value.orgIds.length) {
      callback();
      return;
    }
    if (value.positionIds && value.positionIds.length) {
      callback();
      return;
    }
    if (value.positionCategoryIds && value.positionCategoryIds.length) {
      callback();
      return;
    }
    if (value.personIds && value.personIds.length) {
      callback();
      return;
    }
  }
  callback("请选择受众");
};

class VerbalTrickDetail extends WizContainer {
  componentName = "verbalTrickDetail";

  constructor(props) {
    super(props);
    const { history } = props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/verbalTrick/verbalTrickUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        Session.set('verbalTrickInfo', initialValue)
      } else {
        initialValue = Session.get('verbalTrickInfo') || {}
      }
    }

    this.initialValue = initialValue;
    this.state = {};
  }

  _componentDidMount() {
    if (this.initialValue && this.initialValue.id) {
      this.doAction({
        path: "verbalTrick/look",
        payload: {
          key: "verbalTrickInfo",
          apiParams: { id: this.initialValue.id }
        }
      });
    }
  }

  propsAndStateOnChange = {
    save: this._save.bind(this)
  };

  _save(nextProps, nextState) {
    if (nextProps.save.code == 1) {
      wizNotice.success("保存成功");
      this.jumpPage("replace", "/verbalTrick");
    } else {
      wizNotice.error("提交失败：" + nextProps.save.msg);
    }
    return true;
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param {Object} fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    console.log("fieldsValue:", fieldsValue);
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    /**
     * 图片参数处理
     */
    let pdf = fitterValues["pdfFile"];
    if (pdf && pdf.length) {
      fitterValues["fileId"] = pdf[0]["fileId"];
      delete fitterValues["pdfFile"];
    }
    fitterValues["categoryId"] = fitterValues["categoryId"]?.[0] || "";
    fitterValues["publishTime"] = moment(fitterValues["publishTime"]).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    fitterValues["authCmd"] = formatAuth(fitterValues["authCmd"]);
    return fitterValues;
  }

  _addVerbalTrick(values) {
    let fitterValues = this.fitterFieldsValue(values);
    this.doAction({
      path: "verbalTrick/save",
      payload: {
        key: "save",
        apiParams: { ...fitterValues }
      }
    });
  }

  _validator = (rule, value, callback) => {
    let { changeVerbalTrick } = this.state;
    if (changeVerbalTrick && changeVerbalTrick[0]) {
      if (changeVerbalTrick[0].status !== "done") {
        callback("上传话术中");
        return;
      }
    }
    callback();
  };

  _labelValidator = (rule, value, callback) => {
    if (value && value.length > 3) {
      wizNotice.warn("标签最多选择3个");
      callback("标签最多选择3个");
    }
    callback();
  };

  _render() {
    const { verbalTrickLoading, verbalTrickInfo } = this.props;
    let initialValue = this.initialValue || {};
    if (verbalTrickInfo && verbalTrickInfo.success) {
      initialValue = verbalTrickInfo.data;
    }
    // console.log("initialValue:", initialValue);
    let columns = [
      {
        name: "id",
        formItem: {
          type: "hidden",
          initialValue: initialValue.id
        }
      },
      {
        title: "所属分类",
        name: "categoryId",
        dataIndex: "categoryId",
        formItem: {
          type: "diy",
          diy: ClassifySelect,
          returnKey: true,
          keepPreviousVal: true,
          wizTreeSelectListProps: {
            itemProps: {
              icon: "unordered-list",
              title: "所属分类",
              tips: "请勾选所属分类",
            },
            treeProps: { checkStrictly: true },
            checkable: false,
            leftViewSpan: 24,
            showSelectList: false,
            autoExpand: true,
            // checkType:'child'
          },
          apiProps: { type: 16 },
          selectProps: {
            placeholder: "请选择所属分类"
          },
          rules: [
            {
              required: true,
              message: "请选择所属分类"
            }
          ],
          cancelKeepBeforeVal: true,
          initialValue: initialValue.categoryId
            ? [initialValue.categoryId]
            : [],
          initSelects: initialValue.categoryId
            ? [
              {
                key: initialValue.categoryId,
                title: initialValue.categoryName
              }
            ]
            : []
          //onClearWiz: this._onClearWiz.bind(this)
        }
      },
      {
        title: "话术",
        name: "name",
        formItem: {
          maxLength: 50,
          placeholder: "话术最多输入50个字",
          initialValue: initialValue.name,
          rules: [
            {
              required: true,
              message: "请输入话术"
            }
          ]
        }
      },
      {
        title: "版本号",
        name: "version",
        formItem: {
          maxLength: 15,
          placeholder: "版本号最多输入15个字",
          initialValue: initialValue.version,
          rules: [
            {
              required: true,
              message: "请输入版本号"
            }
          ]
        }
      },
      {
        title: "话术文件",
        name: "pdf",
        formItem: {
          type: "custom",
          render: (record, form) => {
            const { getFieldDecorator } = form;
            let children = <WizButton> 上传话术 </WizButton>;
            return (
              <WizRow>
                <WizCol span={4}>
                  {getFieldDecorator("pdfFile", {
                    initialValue: initialValue.fileId
                      ? [{ fileId: initialValue.fileId }]
                      : [],
                    rules: [
                      { required: true, message: "话术文件不能为空" },
                      { validator: this._validator }
                    ]
                  })(
                    <WizFileUpload
                      key="pdfFile"
                      accept={".pdf"}
                      listType={"text"}
                      limit={-1}
                      progress={{
                        strokeColor: { "0%": "#108ee9", "100%": "#87d068" },
                        strokeWidth: 3,
                        format: percent => `${parseFloat(percent.toFixed(2))}%`
                      }}
                      beforeUpload={(file, upload, remove) => {
                        let result = true;
                        const isLt1G = file.size / 1024 / 1024 < 1024;
                        if (!isLt1G) {
                          Wizmessage.error("话术不得超过1GB!");
                          result = false;
                        }
                        return result;
                      }}
                      children={children}
                    />
                  )}
                </WizCol>
                <WizCol span={20}> (只支持上传PDF文件) </WizCol>
              </WizRow>
            );
          }
        }
      },
      {
        title: "适用品牌",
        name: "orgIds",
        dataIndex: "orgIds",
        formItem: {
          ...organizationConfig,
          diy: WizTableForm,
          selectType: "checkbox",
          initialValue: initialValue.orgList?.map(item => item.id) || [],
          initRows: initialValue.orgList || [],
          rules: [{ required: true, message: "请选择适用品牌" }]
        }
      },
      {
        title: "标签",
        name: "labelIds",
        formItem: {
          ...labelConfig,
          diy: WizTableForm,
          initialValue: initialValue.labelList?.map(item => item.id) || [],
          initRows: initialValue.labelList || [],
          selectType: "checkbox",
          rules: [{ validator: this._labelValidator }]
        }
      },
      {
        title: "发布日期",
        name: "publishTime",
        formItem: {
          type: "date",
          format: "YYYY-MM-DD",
          rules: [{ required: true, message: "请选择发布日期" }],
          initialValue: initialValue && initialValue.publishTime
        }
      },
      {
        title: "有效期",
        name: "effectiveTime",
        formItem: {
          type: "custom",
          rules: [{ required: true, message: "请输入有效期" }],
          render: (record, form) => {
            const { getFieldDecorator, validateFields } = form
            const effectiveTimeValidator = (rule, value, callback) => {
              if (value && !(/(^[1-9]\d*$)/.test(value))) {
                callback('必须为正整数')
              }
              callback();
            }
            return (
              <WizRow>
                <WizCol span={4}>
                  {getFieldDecorator("effectiveTime", {
                    initialValue: initialValue.effectiveTime,
                    rules: [
                      { required: true, message: "请输入有效期" },
                      { validator: effectiveTimeValidator }
                    ]
                  })(<WizInputNumber min={0} max={99} />)}
                </WizCol>
                <WizCol span={2} push={1}>
                  {getFieldDecorator("timeType", {
                    initialValue: initialValue.timeType || 1
                  })(
                    <WizSelect placeholder="请选择有效期类型">
                      <Option value={1}> 月 </Option>
                      <Option value={2}> 年 </Option>
                    </WizSelect>
                  )}
                </WizCol>
              </WizRow>
            );
          }
        }
      },
      {
        title: "受众",
        name: "authCmd",
        formItem: {
          type: "custom",
          render: (record, form) => {
            record = initialValue;
            const { getFieldDecorator, setFieldsValue } = form;
            const authChange = (e) => {
              setFieldsValue({
                authCmd: e
              })
            }
            return (
              <WizCol style={{ borderWidth: 1, borderColor: '#F0F2F5', borderStyle: 'solid', paddingTop: 20 }}>
                {
                  getFieldDecorator('authCmd',
                    {
                      rules: [{ required: true, validator }],
                      initialValue: Object.assign({}, record.authInfo)
                    })(
                      <div>
                        <WizDataAuthSelect value={Object.assign({}, record.authInfo)} onChange={(e) => { authChange(e) }} />
                      </div>
                    )
                }
              </WizCol>
            );
          }
        }
      },
      {
        title: "状态",
        name: "state",
        formItem: {
          type: "radio",
          initialValue:
            initialValue.state === null || initialValue.state === undefined
              ? 1
              : initialValue.state
        },
        dict: [{ code: 1, codeName: "启用" }, { code: 0, codeName: "禁用" }]
      }
    ];

    let onSubmit = this._addVerbalTrick.bind(this);

    let formProps = {
      ref: "form",
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      }
    };

    return (
      <WizCard className="trick">
        <WizSpin tip={"加载中"} spinning={verbalTrickLoading}>
          <WizForm className={"form-inline"} {...formProps} />
        </WizSpin>
      </WizCard>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { verbalTrick } = state;
  const save = modelUtils.getModelEntity(verbalTrick, "save");
  const verbalTrickInfo = modelUtils.getModelEntity(
    verbalTrick,
    "verbalTrickInfo"
  );
  const load = modelUtils.getLoadingState(state, "verbalTrick");
  return {
    save,
    verbalTrickInfo,
    ...load
  };
};

export default connect(mapStateToProps)(VerbalTrickDetail);
